var $ = require('jquery');

$('.js-related-stories__load-all').on('click', function (e) {
	e.preventDefault();
	$(this).parents('.related-stories__container').find('.related-stories__grid-item--is-hidden').removeClass('related-stories__grid-item--is-hidden');
	$(this).hide();
})
